import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const VolleyballIcon = observer('VolleyballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='volleyballMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M14.4 6.192 8.667 2.875v-1.45a6.4 6.4 0 0 1 3.6 1.508A6.7 6.7 0 0 1 14.4 6.192M4.5 9.325V2.392a7.6 7.6 0 0 1 1.367-.634 6.7 6.7 0 0 1 1.483-.333v6.25zm-2.567 1.483a6 6 0 0 1-.45-1.325q-.15-.69-.15-1.425A6.6 6.6 0 0 1 1.8 5.6a6.4 6.4 0 0 1 1.367-2.108v6.583zm2.934 3.117a5.4 5.4 0 0 1-1.267-.833 6 6 0 0 1-1-1.134l5.417-3.133 2.85 1.65zm3.15.8a8 8 0 0 1-.784-.042 5 5 0 0 1-.766-.141l5.733-3.3 1.233.683a6.86 6.86 0 0 1-2.375 2.05q-1.425.75-3.041.75m6.066-3.933L8.667 7.675V4.392l6 3.483q0 .766-.134 1.5a5.8 5.8 0 0 1-.45 1.417'
                />
            </mask>
            <g mask='url(#volleyballMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
